import React from "react";
import isEmpty from "lodash/isEmpty";
import {GridItem} from "@/widget/GridItem/GridItem";
import {useQueryExpense} from "@/service/expense.s";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import {Grid, Stack} from "@mui/material";
import {checkQueryKey, formatTime} from "@/helper/method";
import {useDrawerModal} from "@/store/global.c";
import {ProTable} from "@/widget/ProTable/ProTable";
import {FundPO} from "@/model/finance";
import {GridColDef} from "@mui/x-data-grid";

export const ViewExpense = () => {
    const {id: drawerId} = useDrawerModal()
    const {data: expenseData, isLoading: expenseLoading} = useQueryExpense({id: drawerId!}, checkQueryKey(drawerId))
    const expense = expenseData?.data

    const columns: GridColDef<FundPO>[] = [
        {field: "name", headerName: "款项名称", flex: 0.3},
        {field: "money", headerName: "款项金额", flex: 0.3},
        {field: "remark", headerName: "摘要", flex: 0.5},
    ]

    return <> <ResultWrapper isLoading={expenseLoading} isEmpty={isEmpty(expense)}>
        <Stack direction={'column'} width={'100%'} gap={2}>
            <Grid
                spacing={3}
                container>
                <GridItem title={'支付类型'} content={expense?.categories}/>
                <GridItem title={'支付时间'} content={formatTime('D', expense?.payTime)}/>
                <GridItem title={'总金额'} content={expense?.totalMoney}/>
                <GridItem title={'客户名称'} content={expense?.customerName}/>
                <GridItem title={'支付人'} content={expense?.creator}/>
                <GridItem title={'收款名称'} content={expense?.receiptName}/>
                <GridItem title={'收款账号'} content={expense?.receiptAccount}/>
                <GridItem title={'收款银行'} content={expense?.receiptBank}/>
                <ProTable<any> checkboxSelection={false} autoHeight={false} columnHeaderHeight={40} loading={expenseLoading}
                               pageSize={5} showToolbar={false}
                               rowId={'name'}
                               columns={columns} source={{
                    dataSource: {
                        getRows: async () => {
                            return {rows: expense?.funds || [], rowCount: expense?.funds?.length}
                        }
                    }, rowCount: expense?.funds?.length || 0
                }}/>

                <GridItem title={'更新时间'} content={formatTime('D', expense?.updatedAt)}/>
                <GridItem title={'创建时间'} content={formatTime('D', expense?.createdAt)}/>
            </Grid>
        </Stack>
    </ResultWrapper>
    </>
}